var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.unreadNotificationCount)?_c('div',{staticClass:"counter"},[_c('span',{staticClass:"counter__count"},[_vm._v("\n    "+_vm._s(_vm.unreadNotificationCount)+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }